export default __webpack_public_path__ + "static/media/import-discount-codes-csv-example.60e298ef.csv";